import { PayloadAction, createListenerMiddleware } from '@reduxjs/toolkit';
import { onHideToastByTitle, onSuccess } from './toast.slice';
import { ToastPayload } from './toast.types';

export const toastMiddleware = createListenerMiddleware();
toastMiddleware.startListening({
  actionCreator: onSuccess,
  effect: async (action: PayloadAction<ToastPayload>, listenerApi) => {
    await listenerApi.delay(5000);

    listenerApi.dispatch(onHideToastByTitle(action.payload.title));
  }
});
